var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "800px",
            "before-close": _vm.hide,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryParams,
                rules: _vm.rules,
                "label-position": "left",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("BjSelectChannelStore", {
                    attrs: {
                      span: 12,
                      "query-params": _vm.queryParams,
                      "query-props": ["channel", "storeCode"],
                    },
                    on: {
                      handleChannelChange: _vm.handleChannelChange,
                      handleStoreChange: _vm.handleStoreChange,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "DetailsOfThirdPartyAfterSalesOrder.time"
                            ),
                            prop: "queryParamsTime",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticClass: "full-width",
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetimerange",
                              "picker-options": _vm.$pickerOptions(),
                              align: "right",
                              "start-placeholder": _vm.$t("form.startDateText"),
                              "end-placeholder": _vm.$t("form.endDateText"),
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            model: {
                              value: _vm.queryParams.queryParamsTime,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryParams,
                                  "queryParamsTime",
                                  $$v
                                )
                              },
                              expression: "queryParams.queryParamsTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 12 } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer mt20",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.resetForm } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("StoreDialog", {
        ref: "storeDialog",
        on: { confirm: _vm.dialogListConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }